import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "font-semibold text-xl text-black-lp-100 border-b border-gray-lp-1300 w-full py-2.5 px-8 font-montserrat flex items-center justify-between" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { class: "flex flex-row w-full gap-2 " }
const _hoisted_4 = { class: "flex flex-row gap-2" }
const _hoisted_5 = { class: "flex flex-row gap-2" }
const _hoisted_6 = {
  key: 0,
  class: "p-3 flex items-center gap-x-4 justify-between"
}
const _hoisted_7 = { class: "flex items-center gap-x-4 flex-grow" }
const _hoisted_8 = {
  key: 1,
  class: "text-black-lp-300 text-sm font-medium ml-4"
}
const _hoisted_9 = { class: "bg-white w-4 h-4 rounded-full flex items-center justify-center" }
const _hoisted_10 = { class: "text-14px pt-5 text-black-lp-300 font-bold" }
const _hoisted_11 = { class: "flex items-center justify-center py-3" }
const _hoisted_12 = { class: "text-gray-lp-600 line-through text-14px mr-3" }
const _hoisted_13 = { class: "text-red-lp-100 font-bold text-18px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_SkeletonModalShipmentV3 = _resolveComponent("SkeletonModalShipmentV3")!
  const _component_SttManualReference = _resolveComponent("SttManualReference")!
  const _component_DetailSender = _resolveComponent("DetailSender")!
  const _component_BookingSdnBanner = _resolveComponent("BookingSdnBanner")!
  const _component_DetailReceiver = _resolveComponent("DetailReceiver")!
  const _component_GoodsNames = _resolveComponent("GoodsNames")!
  const _component_CommoditySection = _resolveComponent("CommoditySection")!
  const _component_DeliveryService = _resolveComponent("DeliveryService")!
  const _component_DetailKoli = _resolveComponent("DetailKoli")!
  const _component_InsuranceBanner = _resolveComponent("InsuranceBanner")!
  const _component_SectionUploadPhotoForWeightAdjusment = _resolveComponent("SectionUploadPhotoForWeightAdjusment")!
  const _component_DocInternational = _resolveComponent("DocInternational")!
  const _component_DeliveryType = _resolveComponent("DeliveryType")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_SectionFooterBookingV3 = _resolveComponent("SectionFooterBookingV3")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Dialog, {
      modelValue: _ctx.visible,
      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => (_ctx.visible = $event)),
      header: false,
      persistent: "",
      customBody: "p-0",
      showOverflow: "",
      customHeight: "calc(80vh / var(--viewport-scale)) !important",
      contentId: "modal-shipment-v3-parent",
      id: "modal-shipment-v3-parent"
    }, {
      header: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          (_ctx.stateCondition.loadingForm)
            ? (_openBlock(), _createBlock(_component_Skeleton, {
                key: 0,
                width: "35%",
                height: "1.8rem"
              }))
            : (_openBlock(), _createBlock("span", _hoisted_2, _toDisplayString(_ctx.shipmentDetail.shipmentId || _ctx.shipmentDetail.shipmentAlgoId), 1)),
          _createVNode(_component_Icons, {
            name: "close",
            class: "w-5 cursor-pointer",
            onClick: _cache[1] || (_cache[1] = () => (_ctx.visible = false))
          })
        ])
      ]),
      "main-footer": _withCtx(() => [
        (_ctx.stateCondition.loadingForm)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_Skeleton, {
                  width: "15%",
                  height: "2.5rem"
                }),
                _createVNode(_component_Skeleton, {
                  width: "12%",
                  height: "2.5rem"
                }),
                _createVNode(_component_Skeleton, {
                  width: "15%",
                  height: "2.5rem"
                })
              ]),
              _createVNode(_component_Skeleton, {
                width: "10%",
                height: "2.5rem",
                class: "flex-none"
              })
            ]))
          : (_openBlock(), _createBlock(_component_SectionFooterBookingV3, {
              key: 1,
              id: "modal-shipment-v3-footer",
              formType: _ctx.isCustomerAppsPrefix ? 'manual' : 'client',
              class: "w-full font-montserrat",
              paymentMethod: _ctx.form.checkoutPaymentMethod,
              "onUpdate:paymentMethod": _cache[35] || (_cache[35] = ($event: any) => (_ctx.form.checkoutPaymentMethod = $event)),
              payload: {},
              estimationPrice: _ctx.masterData.tarifEstimation,
              totalPiece: _ctx.form.pieces.length,
              totalGrossWeight: _ctx.bookingSummary.totalGrossWeight,
              totalDimensionWeight: _ctx.bookingSummary.totalVolumeWeight,
              totalVolumeWeight: _ctx.bookingSummary.totalVolumeWeight,
              chargeableWeight: _ctx.bookingSummary.totalChargeableWeight,
              isCampaign: false,
              goodsValue: _ctx.form.estimationPrice,
              isErrorEstimation: _ctx.errors.estimationPrice,
              isLoadingEstimation: _ctx.stateCondition.loadingEstimationPrice,
              isCodRetailApplied: _ctx.form.isCOD || _ctx.form.isDFOD,
              formCheckTariff: _ctx.form,
              isValid: !_ctx.disabled.submit,
              isDisabled: _ctx.disabled.submit,
              idTariff: "id-tariff-booking-v3",
              adjustmentRuleTariff: _ctx.configRule.tariff,
              configShowPayment: false,
              isButtonSubmit: _ctx.isLastShipment,
              onSubmit: _ctx.processShipmentId,
              onRefresh: _ctx.getEstimationPrice,
              isCustomerApps: _ctx.isCustomerAppsPrefix,
              isBookingShipment: true,
              isCrossCountryCod: _ctx.isCrossCountryCod,
              prefixCurrency: _ctx.prefixCurrency
            }, {
              "footer-right": _withCtx(() => [
                (_ctx.data.length && _ctx.selectedIndex < _ctx.data.length - 1)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 0,
                      id: "button_skip_booking_create_shipment",
                      title: _ctx.$t('bookingV3.shipment.modal.skipBooking'),
                      textColor: "red-lp-100",
                      color: "red-lp-100",
                      outline: "",
                      customClass: "focus:ring-2 focus:ring-blue",
                      onClick: _ctx.onSkipBooking
                    }, null, 8, ["title", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.data.length && _ctx.selectedIndex < _ctx.data.length - 1)
                  ? (_openBlock(), _createBlock("div", _hoisted_8, _toDisplayString(_ctx.selectedIndex + 1) + "/" + _toDisplayString(_ctx.data.length), 1))
                  : _createCommentVNode("", true),
                (_ctx.data.length && _ctx.selectedIndex < _ctx.data.length - 1)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 2,
                      id: "button_booking_create_shipment",
                      title: "Booking",
                      textColor: "white",
                      customClass: "focus:ring-2 focus:ring-blue",
                      onClick: _ctx.processShipmentId,
                      disabled: _ctx.disabled.submit
                    }, {
                      suffix: _withCtx(() => [
                        _createVNode("div", _hoisted_9, [
                          _createVNode(_component_Icons, {
                            name: "arrow-up",
                            class: ["w-2", {
                    'text-gray-lp-600': _ctx.disabled.submit,
                    'text-red-lp-100': !_ctx.disabled.submit
                  }],
                            style: {"transform":"rotate(90deg)"}
                          }, null, 8, ["class"])
                        ])
                      ]),
                      _: 1
                    }, 8, ["onClick", "disabled"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["formType", "paymentMethod", "estimationPrice", "totalPiece", "totalGrossWeight", "totalDimensionWeight", "totalVolumeWeight", "chargeableWeight", "goodsValue", "isErrorEstimation", "isLoadingEstimation", "isCodRetailApplied", "formCheckTariff", "isValid", "isDisabled", "adjustmentRuleTariff", "isButtonSubmit", "onSubmit", "onRefresh", "isCustomerApps", "isCrossCountryCod", "prefixCurrency"]))
      ]),
      default: _withCtx(() => [
        (_openBlock(), _createBlock("div", {
          key: _ctx.selectedIndex,
          class: "flex flex-col gap-y-2 px-4 py-1.5 bg-gray-lp-700 font-montserrat overflow-auto",
          style: {"width":"calc(80vw / var(--viewport-scale)) !important"},
          tabindex: "0"
        }, [
          (_ctx.stateCondition.loadingForm)
            ? (_openBlock(), _createBlock(_component_SkeletonModalShipmentV3, { key: 0 }))
            : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_SttManualReference, {
                  id: "edit-booking-retail-stt-manual",
                  modelValue: _ctx.form,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form = $event)),
                  currentIndex: _ctx.currentIndex,
                  "onUpdate:currentIndex": _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentIndex = $event)),
                  error: _ctx.errors,
                  "onUpdate:error": _cache[4] || (_cache[4] = ($event: any) => (_ctx.errors = $event)),
                  sttNoRefExternalIndex: 1,
                  isSttAdjustClient: "",
                  isDO: _ctx.shipmentDetail.isDO,
                  configManualStt: _ctx.configRule.manualSttNo,
                  configRefExternal: _ctx.configRule.sttNoRefExternal
                }, null, 8, ["modelValue", "currentIndex", "error", "isDO", "configManualStt", "configRefExternal"]),
                _createVNode(_component_DetailSender, {
                  modelValue: _ctx.form,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form = $event)),
                  currentIndex: _ctx.currentIndex,
                  "onUpdate:currentIndex": _cache[6] || (_cache[6] = ($event: any) => (_ctx.currentIndex = $event)),
                  errors: _ctx.errors,
                  "onUpdate:errors": _cache[7] || (_cache[7] = ($event: any) => (_ctx.errors = $event)),
                  senderNameIndex: 2,
                  senderPhoneIndex: 3,
                  senderAddressIndex: 4,
                  saveSenderIndex: 5,
                  configName: _ctx.configRule.senderName,
                  configPhone: _ctx.configRule.senderPhone,
                  configSaveAddress: _ctx.configRule.senderSave,
                  configAddress: _ctx.configRule.senderAddress,
                  configRule: _ctx.configRule,
                  checkFraud: _ctx.checkFraudSenderPhone,
                  isPhoneCodeSet: !!_ctx.form.phoneSender
                }, null, 8, ["modelValue", "currentIndex", "errors", "configName", "configPhone", "configSaveAddress", "configAddress", "configRule", "checkFraud", "isPhoneCodeSet"]),
                _createVNode(_component_DetailReceiver, {
                  id: "booking-receiver-section",
                  modelValue: _ctx.form,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form = $event)),
                  postalCodeDestination: _ctx.form.postalCodeDestination,
                  "onUpdate:postalCodeDestination": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.postalCodeDestination = $event)),
                  currentIndex: _ctx.currentIndex,
                  "onUpdate:currentIndex": _cache[10] || (_cache[10] = ($event: any) => (_ctx.currentIndex = $event)),
                  errors: _ctx.errors,
                  "onUpdate:errors": _cache[11] || (_cache[11] = ($event: any) => (_ctx.errors = $event)),
                  listKGs: _ctx.form.pieces,
                  recipientNameIndex: 6,
                  recipientPhoneIndex: 7,
                  recipientAddressIndex: 8,
                  recipientDistrictIndex: 9,
                  recipientPostalCodeIndex: 10,
                  saveReceiverIndex: 11,
                  configName: _ctx.configRule.recipientName,
                  configPhone: _ctx.configRule.recipientPhone,
                  configAddress: _ctx.configRule.recipientAddress,
                  configDistrict: _ctx.configRule.recipientDistrict,
                  configPostalCode: _ctx.configRule.recipientPostalCode,
                  configSaveAddress: _ctx.configRule.recipientSave,
                  isEditForm: true,
                  isErrorEmbargo: _ctx.isErrorEmbargoDestination,
                  isBookingShipment: true,
                  isPhoneCodeSet: !!_ctx.form.phoneReceiver,
                  onSelectDistrict: _cache[12] || (_cache[12] = () => _ctx.getUpsellingAndTarif(this))
                }, {
                  "destination-info": _withCtx(() => [
                    _createVNode(_component_BookingSdnBanner, {
                      variant: "v3",
                      originDistrict: _ctx.originDistrictDetail,
                      destinationDistrict: _ctx.form.destinationCity,
                      active: _ctx.visible && !_ctx.stateCondition.loadingForm
                    }, null, 8, ["originDistrict", "destinationDistrict", "active"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "postalCodeDestination", "currentIndex", "errors", "listKGs", "configName", "configPhone", "configAddress", "configDistrict", "configPostalCode", "configSaveAddress", "isErrorEmbargo", "isPhoneCodeSet"]),
                (_ctx.displayGoodsName)
                  ? (_openBlock(), _createBlock(_component_GoodsNames, {
                      key: 0,
                      goodsNames: _ctx.goodsName
                    }, null, 8, ["goodsNames"]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_3, [
                  _createVNode(_component_CommoditySection, {
                    id: "input_commodity_create_shipment",
                    modelValue: _ctx.form,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form = $event)),
                    currentIndex: _ctx.currentIndex,
                    "onUpdate:currentIndex": _cache[14] || (_cache[14] = ($event: any) => (_ctx.currentIndex = $event)),
                    error: _ctx.errors,
                    "onUpdate:error": _cache[15] || (_cache[15] = ($event: any) => (_ctx.errors = $event)),
                    commodityIndex: 12,
                    configCommodity: _ctx.configRule.commodity,
                    isEditForm: true,
                    onSelectCommodity: _cache[16] || (_cache[16] = () => _ctx.getUpsellingAndTarif(this))
                  }, null, 8, ["modelValue", "currentIndex", "error", "configCommodity"]),
                  _createVNode(_component_DeliveryService, {
                    id: "booking-delivery-service-section",
                    "id-non-cod": "button_non_cod_create_shipment",
                    "id-cod": "button_cod_create_shipment",
                    "id-dfod": "button_dfod_create_shipment",
                    modelValue: _ctx.form.serviceType,
                    "onUpdate:modelValue": [
                      _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.serviceType = $event)),
                      _ctx.onUpdateServiceType
                    ],
                    woodpacking: _ctx.form.woodpacking,
                    "onUpdate:woodpacking": _cache[18] || (_cache[18] = ($event: any) => (_ctx.form.woodpacking = $event)),
                    currentIndex: _ctx.currentIndex,
                    "onUpdate:currentIndex": _cache[19] || (_cache[19] = ($event: any) => (_ctx.currentIndex = $event)),
                    error: _ctx.errors,
                    "onUpdate:error": _cache[20] || (_cache[20] = ($event: any) => (_ctx.errors = $event)),
                    serviceTypeIndex: 13,
                    originDistrictDetailCode: _ctx.originDistrictDetail.cityCode,
                    destination: _ctx.form.destinationCity,
                    isLimited: _ctx.phoneFraudData.limited,
                    isBlacklist: _ctx.phoneFraudData.blacklist,
                    disabled: _ctx.disabled.serviceType,
                    disabledCOD: _ctx.isApAsRouteCodDisabled,
                    disabledDFOD: _ctx.isApAsRouteCodDisabled,
                    configDeliveryService: _ctx.configRule.serviceType,
                    isEdit: "",
                    hideWoodpacking: true,
                    isClient: _ctx.isClient
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "woodpacking", "currentIndex", "error", "originDistrictDetailCode", "destination", "isLimited", "isBlacklist", "disabled", "disabledCOD", "disabledDFOD", "configDeliveryService", "isClient"])
                ]),
                _createVNode("div", _hoisted_4, [
                  _createVNode(_component_DetailKoli, {
                    form: _ctx.form,
                    "onUpdate:form": _cache[21] || (_cache[21] = ($event: any) => (_ctx.form = $event)),
                    pieces: _ctx.form.pieces,
                    "onUpdate:pieces": _cache[22] || (_cache[22] = ($event: any) => (_ctx.form.pieces = $event)),
                    currentIndex: _ctx.currentIndex,
                    "onUpdate:currentIndex": _cache[23] || (_cache[23] = ($event: any) => (_ctx.currentIndex = $event)),
                    error: _ctx.errors,
                    "onUpdate:error": _cache[24] || (_cache[24] = ($event: any) => (_ctx.errors = $event)),
                    listCodActive: _ctx.masterData.codActiveConfig,
                    listDfodActive: _ctx.masterData.dfodActiveConfig,
                    maxPieces: _ctx.maxPieces,
                    insuranceData: _ctx.masterData.insuranceConfig,
                    hwsMinimumData: _ctx.hwsMinimumData,
                    goodsPriceIndex: 14,
                    codAmountIndex: 15,
                    insuranceIndex: 16,
                    pieceIndex: 17,
                    configGoodsPrice: _ctx.configRule.goodsPrice,
                    configInsurance: _ctx.configRule.insurance,
                    configCodAmount: _ctx.configRule.codAmount,
                    configGrossWeight: _ctx.configRule.grossWeight,
                    configDimension: _ctx.configRule.dimension,
                    configAdjustPieceAdd: _ctx.configRule.adjustPiece,
                    configAdjustPieceRemove: _ctx.configRule.adjustPiece,
                    disabledWeight: _ctx.disabled.adjustmentWeight,
                    disabledDimension: _ctx.disabled.adjustmentWeight,
                    onUpdateEstimationPrice: _cache[25] || (_cache[25] = () => _ctx.getUpsellingAndTarif(this)),
                    onUpdateGrossWeight: _cache[26] || (_cache[26] = () => _ctx.getUpsellingAndTarif(this)),
                    isShipment: _ctx.isShipment,
                    dataRuleShipmentBooking: _ctx.dataRuleShipmentBooking,
                    eligibleEditSize: _ctx.isCustomerPrefixEligibleEditSize,
                    isBookingShipment: true,
                    formType: 
              _ctx.isCustomerAppsPrefix || _ctx.validationPrefix(['T'])
                ? 'manual'
                : 'client'
            ,
                    bookingType: "shipment",
                    totalChargeableWeight: _ctx.bookingSummary.totalChargeableWeight,
                    schemaGoodsPriceType: _ctx.minMaxType,
                    excludeEstimationValidation: _ctx.excludeEstimationValidation,
                    insuranceBasic: _ctx.insuranceBasic,
                    isRetail: true,
                    isForceShowInsurance: true,
                    isCrossCountryRoute: _ctx.isCrossCountryRoute
                  }, null, 8, ["form", "pieces", "currentIndex", "error", "listCodActive", "listDfodActive", "maxPieces", "insuranceData", "hwsMinimumData", "configGoodsPrice", "configInsurance", "configCodAmount", "configGrossWeight", "configDimension", "configAdjustPieceAdd", "configAdjustPieceRemove", "disabledWeight", "disabledDimension", "isShipment", "dataRuleShipmentBooking", "eligibleEditSize", "formType", "totalChargeableWeight", "schemaGoodsPriceType", "excludeEstimationValidation", "insuranceBasic", "isCrossCountryRoute"]),
                  _createVNode(_component_InsuranceBanner, { type: "insurance-retail" })
                ]),
                (!_ctx.adjustmentWeightNotAllowed)
                  ? (_openBlock(), _createBlock(_component_SectionUploadPhotoForWeightAdjusment, {
                      key: 1,
                      title: _ctx.$t('bookingV3.shipment.weightPieces.uploadWeightProofPhoto'),
                      marginBottom: false,
                      defaultOpened: false,
                      showViewAdjustment: _ctx.stateCondition.openAdjustmentWeight,
                      "onUpdate:showViewAdjustment": _cache[27] || (_cache[27] = ($event: any) => (_ctx.stateCondition.openAdjustmentWeight = $event)),
                      modelValue: _ctx.form.adjustmentWeightAttachments,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.form.adjustmentWeightAttachments = $event)),
                      onOnUploadImage: _ctx.onUploadAdjustmentWeight,
                      onOnDeleteImage: _ctx.onRemoveAdjustmentWeight,
                      onShowViewAdjustment: _cache[29] || (_cache[29] = ($event: any) => (
            _ctx.stateCondition.openAdjustmentWeight = !_ctx.stateCondition.openAdjustmentWeight
          )),
                      watermark: _ctx.form.shipmentId
                    }, null, 8, ["title", "showViewAdjustment", "modelValue", "onOnUploadImage", "onOnDeleteImage", "watermark"]))
                  : _createCommentVNode("", true),
                (_ctx.isShowSectionCipl)
                  ? (_openBlock(), _createBlock(_component_DocInternational, {
                      key: 2,
                      modelValue: _ctx.form.docInternationalForm,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.form.docInternationalForm = $event)),
                      currentIndex: _ctx.currentIndex,
                      "onUpdate:currentIndex": _cache[31] || (_cache[31] = ($event: any) => (_ctx.currentIndex = $event)),
                      error: _ctx.errors,
                      "onUpdate:error": _cache[32] || (_cache[32] = ($event: any) => (_ctx.errors = $event)),
                      isFtz: false,
                      internationalDocumentDetailData: _ctx.internationalDocumentDetailData,
                      destinationCityId: _ctx.destinationCity.cityId,
                      originCityId: _ctx.originDistrictDetail.cityId,
                      indexListCommodityCIPL: 16,
                      indexEmail: 17,
                      indexIdNumber: 18,
                      indexTaxNumber: 19,
                      indexShipmentStatus: 20,
                      indexImageBeforePackingUrl: 21,
                      indexImageAfterPackingUrl: 22,
                      indexImageIdUrl: 23,
                      indexImageTaxUrl: 24,
                      configInterCipl: _ctx.configRule.interCipl,
                      configInterEmail: _ctx.configRule.interCipl,
                      configInterIdentityNo: _ctx.configRule.interCipl,
                      configInterTaxNo: _ctx.configRule.interCipl,
                      configInterImageAfterPacking: _ctx.configRule.interCipl,
                      configInterImageBeforePacking: _ctx.configRule.interCipl,
                      configInterImageTaxNo: _ctx.configRule.interCipl,
                      configInterImageEmail: _ctx.configRule.interCipl
                    }, null, 8, ["modelValue", "currentIndex", "error", "internationalDocumentDetailData", "destinationCityId", "originCityId", "configInterCipl", "configInterEmail", "configInterIdentityNo", "configInterTaxNo", "configInterImageAfterPacking", "configInterImageBeforePacking", "configInterImageTaxNo", "configInterImageEmail"]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_DeliveryType, {
                    key: _ctx.stateCondition.loadingUpselling,
                    class: "w-full",
                    fullHeight: "",
                    currentIndex: _ctx.currentIndex,
                    "onUpdate:currentIndex": _cache[33] || (_cache[33] = ($event: any) => (_ctx.currentIndex = $event)),
                    modelValue: _ctx.form.productName,
                    "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.form.productName = $event)),
                    isErrorUpselling: !!_ctx.errors.upselling,
                    productIndex: 35,
                    listProduct: _ctx.productList,
                    isLoadingUpselling: _ctx.stateCondition.loadingUpselling,
                    upsellingData: _ctx.masterData.upsellingList,
                    configProductType: _ctx.configRule.productType,
                    configTariff: _ctx.configRule.tariff,
                    onRetry: _ctx.getUpselling,
                    isCustomerApps: _ctx.isCustomerAppsPrefix,
                    formType: _ctx.isCustomerAppsPrefix ? 'manual' : 'client',
                    isBookingRetail: false,
                    isErrorEstimation: _ctx.errorEstimation,
                    onSetProduct: _ctx.getEstimationPrice
                  }, null, 8, ["currentIndex", "modelValue", "isErrorUpselling", "listProduct", "isLoadingUpselling", "upsellingData", "configProductType", "configTariff", "onRetry", "isCustomerApps", "formType", "isErrorEstimation", "onSetProduct"]),
                  _createVNode(_component_InsuranceBanner, { type: "shipment" })
                ])
              ], 64))
        ]))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.stateCondition.confirmClose)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onSubmit: _ctx.onCloseForm,
          onClose: () => (_ctx.stateCondition.confirmClose = false),
          title: _ctx.$t('bookingV3.shipment.modal.leaveTitle'),
          message: _ctx.$t('bookingV3.shipment.modal.leaveMessage'),
          image: "badge-warning-lg",
          textSuccess: _ctx.$t('bookingV3.shipment.modal.leave'),
          textCancel: _ctx.$t('bookingV3.shipment.modal.stayHere')
        }, null, 8, ["onSubmit", "onClose", "title", "message", "textSuccess", "textCancel"]))
      : _createCommentVNode("", true),
    (_ctx.stateCondition.successProcess)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          onSubmit: _ctx.onCloseSuccessProcess,
          onClose: () => (_ctx.stateCondition.successProcess = false),
          title: _ctx.$t('bookingV3.shipment.modal.createSuccessTitle'),
          message: _ctx.stateCondition.successProcessMessage,
          image: "image-modal-success",
          textSuccess: "OK"
        }, {
          custom: _withCtx(() => [
            (_ctx.masterData.discount.isDiscount)
              ? (_openBlock(), _createBlock(_component_Card, {
                  key: 0,
                  isShadow: false,
                  class: "mt-3"
                }, {
                  default: _withCtx(() => [
                    _createVNode("h2", _hoisted_10, _toDisplayString(_ctx.$t("bookingShipment.error.totalPayment")), 1),
                    _createVNode("div", _hoisted_11, [
                      _createVNode("div", _hoisted_12, _toDisplayString(_ctx.formatPrice(_ctx.masterData.discount.totalTariff)), 1),
                      _createVNode("div", _hoisted_13, _toDisplayString(_ctx.formatPrice(_ctx.masterData.discount.totalAfterDiscount)), 1)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onSubmit", "onClose", "title", "message"]))
      : _createCommentVNode("", true)
  ], 64))
}